/* eslint-disable import/prefer-default-export */
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';

export const initialCampaign: CampaignConfig = {
  CampaignConfig: {
    Version: 0,
    Name: '',
    Type: 'V',
    Target: 'COVID',
    Iterations: [],
  },
  iteration_details: [],
};
